import { useMemo } from 'react';
import { StyleSheet } from 'react-native';

import { Text } from '@/components/TextComponent';
import { Row } from '@/components/lib/components';
import { Box } from '@/components/lib/components/Box';
import { ds } from '@/components/lib/design.system';
import { ProductConfigKeys, useJurisdictionStore } from '@/hooks/use-jurisdiction';

export const RaceToPlaceInfo = () => {
    const raceToPlaceInfo = useJurisdictionStore(
        store => store.jurisdictionSettings?.productConfig?.keyValuePairs?.[ProductConfigKeys.RaceToPlaceInfo]
    );
    const description = raceToPlaceInfo?.description;
    const items = useMemo(() => {
        if (!raceToPlaceInfo) return [];

        return Object.entries(raceToPlaceInfo)
            .filter(([key]) => key !== 'description')
            .map(([icon, text]) => ({ icon, text }));
    }, [raceToPlaceInfo]);

    return (
        <Box px={'s8'}>
            <Text color={ds.colorToken.text.secondary} textAlign={'center'} variant={'bodyMedium'}>
                {description}
            </Text>
            <Box borderRadius={'r16'} backgroundColor={ds.colorToken.background.neutral.subtler} marginTop={'s24'}>
                {items.map(({ icon, text }, index) => {
                    const lastItem = index === items.length - 1;
                    return (
                        <Box key={`${icon}-${index}`}>
                            <Row padding={'s16'} alignItems={'center'}>
                                <Box width={15} marginRight={'s12'}>
                                    <Text fontSize={12}>{icon}</Text>
                                </Box>
                                <Text color={ds.colorToken.text.secondary} variant={'bodyMedium'} style={styles.text}>
                                    {text}
                                </Text>
                            </Row>
                            {lastItem ? null : <Box height={1} backgroundColor={ds.colorToken.border.strong} />}
                        </Box>
                    );
                })}
            </Box>
        </Box>
    );
};

const styles = StyleSheet.create({
    text: {
        flexShrink: 1,
    },
});
